/* eslint-disable import/no-unresolved */
import React from 'react';
import FakeInfiniteScroll from '../FakeInfiniteScroll';
import ResultItem from './resultsPartials/ResultItem';

const ResultsList = ({ cases }) => {
  return (
    <div className="result-list">
      <div className="container">
        <FakeInfiniteScroll items={cases} chunkSize={3}>
          {chunkedCases =>
            chunkedCases.map(caseStudy => {
              return <ResultItem caseStudy={caseStudy} key={caseStudy.id} />;
            })
          }
        </FakeInfiniteScroll>
      </div>
    </div>
  );
};

export default ResultsList;
